export class SnackbarService {
    public showSnackbar(text: string) {
        o_global.eventQBus.emit('assets.snackbar.trigger', { text });
    }
}
